import React, { useState } from "react";
import { FileRejection, useDropzone } from "react-dropzone";

import {
  CheckMarkIcon,
  FileUploadIcon,
} from "../../components/icons/themes/materialdesign";

export type DragAndDropProps = {
  onDropAcceptedHandler: (file: File) => void;
  onDropRejectedHandler: (rejectedFile: FileRejection) => void;
  maxFileSize: number;
};

function DragAndDrop({
  onDropAcceptedHandler,
  onDropRejectedHandler,
  maxFileSize,
}: DragAndDropProps) {
  const [hasValidFile, setHasValidFile] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: maxFileSize,
    onDropAccepted: (acceptedFiles) => {
      setHasValidFile(true);
      onDropAcceptedHandler(acceptedFiles[0]);
    },
    onDropRejected: (rejectedFiles) => {
      setHasValidFile(false);
      onDropRejectedHandler(rejectedFiles[0]);
    },
  });

  const Icon = hasValidFile ? CheckMarkIcon : FileUploadIcon;

  return (
    <section className="container">
      <div
        {...getRootProps({
          className:
            "dropzone p-4 text-center border-dashed border-4 border-gray-100 rounded",
        })}
      >
        <input {...getInputProps()} />
        <Icon fontSize="40" className="text-gray-300" />
        <p className="font-bold">Click to browse files</p>
        <p className="text-sm text-gray-500 font-bold">or drop file here</p>
      </div>
    </section>
  );
}

export default DragAndDrop;
